<template>
  <v-container class="custom-start">
    <!-- META-DATA -->
    <vue-headful
      :title="'Create Your Own Patch' + this.$store.state.app.meta.titleSuffix"
      :description="this.$store.state.app.meta.description" />

    <div class="custom-start__header">
      <h2>Create your own patches</h2>
      <!--
      <p>The only limit is your creativity <i>[insert better copy here]</i></p>
      <div>
        Want to share your design with the community and earn store credit? <a href="">submit your patch</a> instead.
      </div>
      -->
    </div>
    <div class="custom-start__action-row">
      <div
        v-if="!isModernBrowser"
        class="custom-start__lockout">
        <v-icon
          class="custom-start__lockout-icon">
          error
        </v-icon>
        <span>A modern browser is required in order to use this feature.</span>
      </div>
      <div
        v-if="isModernBrowser"
        class="get-started__wrapper">
        <v-btn
          :to="{
            path: '/custom/create'
          }"
          large
          color="primary"
          class="get-started">
          <h4 class="get-started__text">
            get<br>started
          </h4>
        </v-btn>
      </div>
    </div>
    <div class="custom-start__instruction-row">
      <div class="tips">
        <h3 class="tips__header">tips for formatting your image</h3>
        <p class="tips__body-paragraph">
          The optimal size for your document is 1200 pixels wide and 600 pixels tall.
        </p>
        <p class="tips__body-paragraph">
          While any valid image file type will work, a .png will work best.
        </p>
        <p class="tips__body-paragraph">
          It's important to note that the colors on the patch will not be identical to those you see on your screen - though they will be very very close; this is normal when printing a digital image because of how colors are created on your screen vs. how they are created with ink. To best approximate what your patch will look like, set your document color space to <b>EPSON sRGB</b> if available, or another color space for printed media.
        </p>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'CustomStart',
  data() {
    return {
      //
    };
  },
  computed: {
    isModernBrowser() {
      return 'FileReader' in window;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.custom-start
  display: flex
  flex-flow: column nowrap

  &__header
    text-align: center
    @media screen and (max-width: 48rem)
      font-size: 1.5rem

  &__action-row
    display: flex
    flex-flow: column nowrap
    align-items: center
    justify-content: center
    width: 100%
    padding:$base-padding*2
    @media screen and (max-width: 48rem)
      padding-bottom: $base-padding*8

  &__lockout
    display: flex
    flex-flow: column nowrap
    align-items: center
    justify-content: center
    padding: $base-padding*2
    text-align: center
    color: $white
    background-color: $error
    border-radius: $base-border-radius*2
    &-icon
      color: inherit
      font-size: 8rem

.get-started
  height: 12rem
  width: 12rem
  border-radius: 50%
  z-index: 1
  &__text
    line-height: normal
    text-align: center
    text-transform: uppercase
  &__wrapper
    position: relative
    display: flex
    padding: $base-padding*4
    &::before,
    &::after
      content: ''
      position: absolute
      top: 0
      left: 0
      height: 100%
      width: 100%
      background-color: $primary
      opacity: 0
      border-radius: 50%
    &::before
      animation: pulse 4s infinite
    &::after
      animation: pulse 4s 2s infinite

@keyframes pulse
 0%
   top: 25%
   left: 25%
   height: 50%
   width: 50%
   opacity: 1
 75%
   top: 5%
   left: 5%
   height: 90%
   width: 90%
   opacity: .24
 100%
   top: 0
   left: 0
   height: 100%
   width: 100%
   opacity: 0

</style>
